module.exports = __webpack_public_path__ + "img/financial_renming.11cbdf73.png";